import InputField from 'components/fields/InputField';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import UseLoginStore from '../../stores/LoginStore';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  const {loggingIn, hasErrors, errorMessage, user, login, refresh} = UseLoginStore();

  useEffect(() => {
    if (user !== null) {
      navigate('/');
    }
  }, []);

  async function submitLogin(event) {
    event.preventDefault();
    console.log('submitLogin');
    try {
      await login(username, password);
      await refresh(true);
      navigate('/admin/default');
    } catch (e) {
      console.log(`Failed to login user`);
    }
  }

  return (
    <div className="mb-16 mt-16 flex h-full w-full flex-col items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">CashFlo Payment Dashboard</h4>
      <h6>Internal use only</h6>

      <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
        {/* Sign in section */}
        <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
          <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">Sign In</h4>
          <p className="mb-9 ml-1 text-base text-gray-600">Enter your username and password to sign in!</p>
          <InputField
            variant="auth"
            extra="mb-3"
            label="Username*"
            placeholder="CashFlo username"
            id="email"
            type="text"
            onChange={(e: any) => setUsername(e.currentTarget.value)}
          />

          {/* Password */}
          <InputField
            variant="auth"
            extra="mb-3"
            label="Password*"
            placeholder="Min. 8 characters"
            id="password"
            type="password"
            onChange={(e: any) => setPassword(e.currentTarget.value)}
          />
          {/* Checkbox */}
          <button
            onClick={submitLogin}
            className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            {loggingIn ? 'Loading' : 'Login'}
          </button>
          {hasErrors && <div>{errorMessage}</div>}
        </div>
      </div>
    </div>
  );
}
